import { Text, View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: 30,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: '1',
    borderStyle: 'solid',
    borderColor: '#000000',
    borderTop: 'none',
    padding: '5'
  },
  rowShaded: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: '1',
    borderStyle: 'solid',
    borderColor: '#000000',
    borderTop: 'none',
    padding: '5',
    backgroundColor: '#EEEEEE'
  },
  nmb: {
    width: '5%'
  },
  name: {
    width: '45%',
  },
  serial: {
    width: '45%',
  },
  count: {
    width: '5%',
    textAlign: 'center'
  },
  noData: {
    width: '100%',
    textAlign: 'center'
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: '1',
    borderStyle: 'solid',
    borderColor: '#000000',
    padding: '5',
    backgroundColor: '#CCCCCC'
  },
  hName: {
    width: '45%',
    fontWeight: 'bold'
  },
  hSerial: {
    width: '40%',
    fontWeight: 'bold'
  },
  hCount: {
    width: '10%',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  totalRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: '1',
    borderStyle: 'solid',
    borderColor: '#000000',
    borderTop: 'none',
    padding: '5',
    backgroundColor: '#CCCCCC'
  },
  total: {
    width: '100%',
    textAlign: 'center'
  }
})

const Table = ({ data, page }) => (
  <View style={styles.tableContainer}>
    <TableHeader />
    <TableRow items={data} page={page} />
  </View>
)

const TableHeader = () => (
  <View style={styles.headerRow}>
    <Text style={styles.nmb}>#</Text>
    <Text style={styles.hName}>Device Name</Text>
    <Text style={styles.hSerial}>Device Serial</Text>
    <Text style={styles.hCount}>Used #</Text>
  </View>
)

const TableRow = ({ items, page }) => {
  return (
    <>
      {items && items.length > 0 && items.map((log, i) => (
        <View style={i%2 === 0 ? styles.row : styles.rowShaded} key={i}>
          <Text style={styles.nmb}>{(i + 1) + (page - 1) * 28}</Text>
          <Text style={styles.name}>{log.name}</Text>
          <Text style={styles.serial}>{log.serial}</Text>
          <Text style={styles.count}>{log.count}</Text>
        </View>
      ))}
      {items.length === 0 && (
        <View style={styles.row} key='no data'>
          <Text style={styles.noData}>No activities for this period</Text>
        </View>
      )}
    </>
  )
}

export default Table
